export const SHOW_NOTIFICATION_TIME = 10000 as const

// Don't change values below, because thery're mapped to API
export const CHECKOUT_SECTIONS = {
  myInfoAndBilling: 'MYINFOANDBILLING',
  myInformation: 'MYINFO',
  delivery: 'DELIVERY',
  deliverySpeed: 'DELIVERYSPEED',
  payment: 'PAYMENT',
  billingAddress: 'BILLINGADDRESS',
  // Payment sections IDs needs to match thir API values in 'paymentModeList'
  cashOnDelivery: 'COD',
} as const

export const SWEDEN_LOCALE = 'sv_se' as const

export const PRODUCT_VISIBLE_THUMBNAILS_COUNT = 5 as const

export const ADDRESS_FORMAT_2_COUNTRIES = ['US', 'AU', 'GB', 'FR', 'CA'] as ReadonlyArray<string>
export const ADDRESS_FORMAT = { default: 1, others: 2 } as const
export const ADDRESSES_TYPES = {
  billing: 'HOME_PAYMENT',
  billingAndDelivery: 'HOME_DELIVERY_PAYMENT',
  delivery: 'DELIVERY',
  payment: 'PAYMENT',
} as const
export const INITIAL_ITEMS_TO_SHOW = 4 as const
export const ADDRESS_NOT_VALIDATED = 'REJECT'
export const ADDRESS_VALIDATED = 'ACCEPT'
export const API_VERSION = {
  ONE: 1,
  TWO: 2,
}
export const NUMBER_OF_INITIAL_ADDRESS_SUGGESTIONS = 5 as const

export const ADDRESS_SECTION_STATES = {
  validateBilling: 'VALIDATEBILLING',
  validateDelivery: 'VALIDATEDELIVERY',
}

// TODO - create key for this to translate to all languages [COWEB-2971]
export const HAZMAT_IMAGE_SCREENREADER_TEXT = 'Hazardous Material'
